"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForkRef = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../utils");
exports.useForkRef = function (refOne, refTwo) {
    return react_1.default.useMemo(function () {
        if (refOne == null && refTwo === null) {
            return null;
        }
        return function (refOb) {
            utils_1.setRef(refOne, refOb);
            utils_1.setRef(refTwo, refOb);
        };
    }, [refOne, refTwo]);
};
//# sourceMappingURL=useForkRef.js.map